var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('div',[_c('h1',{attrs:{"data-h1":_vm.status.code}},[_vm._v(_vm._s(_vm.status.code))]),_c('p',{attrs:{"data-p":_vm.status.text}},[_vm._v(_vm._s(_vm.status.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }